// Recent-impersonation list, capped at 5 items. Stored in localStorage so it
// survives PWA reloads and cold restarts.
const KEY = "em_recent_impersonations_v1";
const CAP = 5;

// Entries are tagged with the workgroup they were made in (the `wg` cookie
// set by the superadmin switcher; no cookie = the domain's default) so a
// list built in Elite never surfaces in Steeltooth or Jasper.
const currentWg = () => {
  try {
    const m = document.cookie.match(/(?:^|;\s*)wg=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : "default";
  } catch {
    return "default";
  }
};

const readAll = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

export const getRecent = () => {
  const wg = currentWg();
  return readAll().filter((x) => (x.wg || "default") === wg).slice(0, CAP);
};

export const rememberImpersonation = (u) => {
  if (!u?.user_id) return;
  try {
    const wg = currentWg();
    const others = readAll().filter((x) => (x.wg || "default") !== wg);
    const existing = getRecent().filter((x) => x.user_id !== u.user_id);
    const entry = {
      wg,
      user_id: u.user_id,
      name: u.name || "",
      email: u.email || "",
      role: u.role || "",
      at: new Date().toISOString(),
    };
    const next = [entry, ...existing].slice(0, CAP);
    localStorage.setItem(KEY, JSON.stringify([...next, ...others]));
  } catch {
    /* ignore quota / private-mode errors */
  }
};

export const forgetImpersonation = (userId) => {
  try {
    const wg = currentWg();
    const next = readAll().filter((x) => !((x.wg || "default") === wg && x.user_id === userId));
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
};
